<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import ProgressSpinner from 'primevue/progressspinner';
import { useAuthStore } from '@/stores/authStore';
import { useRouter, useRoute } from 'vue-router';
import { LOGIN_ROUTER_PAGE } from '@/utils/consts';
import { useApiKeysStore } from '@/stores/apiKeysStore';

const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()
const apiKeysStore = useApiKeysStore()
const { loading } = storeToRefs(authStore)
const mounting = ref(true)

onMounted(async () => {
  try {
    if (route.meta.private == true) {
      await authStore.check()
      if (!authStore.authorized) {
        router.push(LOGIN_ROUTER_PAGE)
        mounting.value = false
        return
      }
      await apiKeysStore.fetchKeys()
    }
  } finally {
    mounting.value = false
  }
})

const isSomeLoading = computed(() => mounting.value || loading.value.check || loading.value.auth)
</script>

<template>
  <div v-if="isSomeLoading" class="w-full h-screen flex justify-center items-center align-center" key="spinner">
    <ProgressSpinner>
    </ProgressSpinner>
  </div>
  <div v-else key="content">
    <slot />
  </div>
</template>
